import {adminHttpClient} from "../commons/adminHttpClient";

const deleteOperator = (id : string) :Promise<any> =>{
    return adminHttpClient.delete(`/Operators/Delete`, {
        data: { id: id }
    });
}

export default deleteOperator;